import { Utils } from '../Utils/Utils';
import { ArgValidator} from '../Utils/ArgValidator';

export abstract class WidgetApiBase {
    protected _id: string;
    protected _jq: JQuery;

    constructor(id: string) {
        ArgValidator.ensureStringIsNotNullOrEmpty(id, 'id');
        this._id = id;
    }

    protected get jq(): JQuery {
        if (!this._jq) {
            this._jq = Utils.getJQueryById(this._id);
        }
        return this._jq;
    }

    protected _changeid(newId: string): JQuery {
        ArgValidator.ensureStringIsNotNullOrEmpty(newId, 'newId');
        this._id = newId;
        this._jq = null;
        return this.jq;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Widgets/WidgetBase.ts
 **/